import { Col, Container, Row } from "react-bootstrap";
import client from "../../Assets/Projects/client project.jpeg";
import food from "../../Assets/Projects/food.jpeg";
import moviefetching from "../../Assets/Projects/movie fetching.jpeg";
import portfolio from "../../Assets/Projects/portfolio.jpeg";
import quiz from "../../Assets/Projects/quiz.jpeg";
import rollthedice from "../../Assets/Projects/roll the dice.jpeg";
import splitbill from "../../Assets/Projects/split bill.jpeg";
import todolist from "../../Assets/Projects/to do list.jpeg";
import weather from "../../Assets/Projects/weather.jpeg";
import Particle from "../Particle";
import ProjectCard from "./ProjectCards";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={todolist}
              isBlog={false}
              title="TO DO LIST "
              description="A simple To-Do List application helps users organize and manage daily tasks efficiently. It allows adding, editing, deleting, and marking tasks as completed. With a clean interface and real-time updates, it improves productivity, tracks progress, and ensures important activities are completed on time without missing deadlines or priorities."
              demoLink="https://travel-list-praveen.netlify.app/"
            />
          </Col>

            <Col md={4} className="project-card">
            <ProjectCard
              imgPath={weather}
              isBlog={false}
              title="WEATHER APP"
              description="Weather App is a simple and user-friendly application that provides real-time weather updates, temperature details, humidity levels, wind speed, and daily forecasts. It helps users plan their activities by showing accurate current conditions and upcoming weather changes with a clean interface and responsive design across all devices for modern users.
"
              demoLink="https://weather-app-praveen-challa.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={portfolio}
              isBlog={false}
              title="PORTFOLIO"
              description="A dynamic To-Do List web application built using modern technologies to efficiently manage daily tasks. It allows users to add, update, delete, and mark tasks as completed with a responsive and user-friendly interface. Designed to improve productivity, the application ensures seamless task tracking and organized workflow management."
              demoLink="https://challa-praveen-kumar-portfolio.netlify.app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={client}
              isBlog={false}
              title="CLIENT PROJECT "
              description="A professional Job Consultancy web application developed for a client to streamline recruitment and hiring processes. The platform enables job posting, candidate registration, resume submission, and application tracking with a secure and user-friendly interface. Designed to connect employers and job seekers efficiently, ensuring smooth communication and effective talent acquisition."
              demoLink="https://koduruyogi.netlify.app/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={splitbill}
              isBlog={false}
              title="BILL SPLIT"
              description="Split Bill is a simple and efficient app that helps users divide expenses easily among friends, family, or colleagues. It calculates individual shares instantly, tracks payments, and avoids confusion in group spending. With a clean interface and accurate calculations, it makes managing shared expenses quick, transparent, and completely hassle-free."
              demoLink="https://eat-and-split-praveen.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={rollthedice}
              isBlog={false}
              title="PIG GAME "
              description="A fun and interactive Roll the Dice game designed to test strategy and luck. Players roll the dice to earn points; numbers below 5 add to the current score. Rolling a 1 resets the total score to zero. Players can hold their score at the right time to secure points and maximize their total."
             
              demoLink="https://pig-game-challa.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={moviefetching}
              isBlog={false}
              title="MOVIE FETCHING "
              description="A dynamic Movie Fetching web application developed using API integration to display real-time movie data. Users can search for movies, view details like ratings, release dates, and descriptions through a responsive and user-friendly interface. Designed to provide seamless browsing experience with fast data retrieval and interactive UI components."
             demoLink="https://movie-fetch-praveen.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={quiz}
              isBlog={false}
              title="QUIZ APPLICATIONS"
              description="A responsive Quiz Application developed to provide an interactive learning and assessment experience. Users can attempt multiple-choice questions, receive instant feedback, and track their scores in real time. The application features dynamic question loading, score calculation, and a user-friendly interface, ensuring an engaging and smooth quiz experience across devices."
              demoLink="https://quiz-praveen.netlify.app/"
            />
          </Col>

          
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={food}
              isBlog={false}
              title="RESPONSIVE FOOD APPLICATION"
              description="A **food application responsive design** built using **HTML and CSS** ensures the interface adapts smoothly to different screen sizes like mobiles, tablets, and desktops. It uses flexible layouts, media queries, and responsive images to display menus, food items, and navigation clearly, providing users with an easy, visually appealing, and seamless ordering experience. 🍔📱💻"
              demoLink="https://omini-food-challa-praveen.netlify.app/"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
